import React from "react";
import "./styles.scss";
import PropTypes from "prop-types";

const Index = ({ data, onChange, onClick }) => {
  let inputElement = null;
  inputElement = (
    <>
      <div className={`filter-color-wrapper`}>
        <div className={`fcw__color1`}></div>
        <div className={`fcw__bottom`}>
          <div className={`fcwb__color2`}></div>
          <div className={`fcwb__color3`}></div>
        </div>
      </div>
    </>
  );
  return <>{inputElement}</>;
};
Index.propTypes = {};

Index.defaultdata = {};

export default Index;
